import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import { kpiFiguresEndpoint } from "~/modules/user/api/kpiFigure/kpiFigureApiEndpoints.ts";
import type { KpiFigures } from "~/modules/user/api/kpiFigure/kpiFigureTypes.ts";

export function getKpiFigures(userId: string): AxiosApiResponsePromise<KpiFigures> {
	return axiosApi.get(kpiFiguresEndpoint(userId));
}
